import React from 'react'
import AccountCreatedPage from '../../components/Fundraiser/FundraiserOnboarding/AccountCreated';

const AccountCreated = () => {
  return (
    <AccountCreatedPage />
  )
}

export default AccountCreated;